import { channelClient, RequestPolicies, type ChannelUnsubscribe } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ProjectModel } from 'shared/domain/project/types/model';
import { selectedProjectContract } from './selectedProjectContract';

/** The project selected in the service worker. */
export const selectedProjectClient = {
  /** Resolves with the project once the worker switched to it and cleared the previous project's data. */
  select(projectId: string): Promise<ProjectModel> {
    // Clearing IndexedDB may take long.
    return channelClient.request(selectedProjectContract, 'select', { projectId }, RequestPolicies.longRunning);
  },

  /** The selected project, `null` when there is none or it cannot be found. */
  getSelected(): Promise<ProjectModel | null> {
    // Waits for the project list when it is not downloaded yet.
    return channelClient.request(selectedProjectContract, 'getSelected', undefined, RequestPolicies.bulkRead);
  },

  /** Every switch of the selected project (also from other tabs); `undefined` when cleared. */
  onSelected(handler: (project: ProjectModel | undefined) => void): ChannelUnsubscribe {
    return channelClient.onEventOfType(selectedProjectContract, DomainMessagesTypes.selectedProject, ({ data }) =>
      handler(data?.project)
    );
  },
};
